/// <reference path="wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        const LOG_CATEGORY = "WPT.Navigation.Menu";
        const UNKNOWN = "Unknown";
        const EXPAND_CLASS = 'menu-navigation__item--expanded';
        const SUBITEM1_CLASS = "menu-navigation__subitem-1";
        const SUBITEM1_SELECTED_CLASS = "menu-navigation__subitem-1--selected";
        const SUBITEM2_CLASS = "menu-navigation__subitem-2";
        const SUBITEM2_SELECTED_CLASS = "menu-navigation__subitem-2--selected";
        const BREAK_CLASS = "menu-navigation__subitem-1--break";
        const TICK_CLASSES = ['menu-navigation__item-icon', 'menu-navigation__item-icon--success', 'wpt-font', 'wpt-font-icon_TickBold'];
        /**
         * Class holding MenuNavigationHandler.
         */
        class MenuNavigationHandler extends Navigation.MenuNavigationHandlerBaseClass {
            constructor(core, navigation) {
                super(core, navigation);
                this._sideNav = null;
                this._sideNavList = null;
                this._customMarker = null;
                this._customNavOptions = null;
                this._coverMe = null;
                this._footer = null;
                this._sideNavWidth = "20em";
                this._applicationOptions = null;
                this._applicationList = null;
                this._applicationOverflow = null;
                this._languageOptions = null;
                this._languageList = null;
                this._languageOverflow = null;
                this._themeOptions = null;
                this._themeList = null;
                this._themeOverflow = null;
                this._logOff = null;
                this._logIn = null;
                this._about = null;
                this._searchList = null;
                this._search = null;
                this._advSearch = null;
                this._upload = null;
                this._workflow = null;
                this._forms = null;
                this._personalList = null;
                this._myFolders = null;
                this._myDocuments = null;
                this._savedSearch = null;
                this._changePw = null;
                this._forgotPw = null;
                this._myProfile = null;
                this._headerLogo = null;
                this._loadingSite = null;
                this._logonPage = null;
                this._bottomHourGlass = null;
                this._navigationIcons = null;
                this._loginIcons = null;
                this._headerFinished = null;
                this._menuFinished = null;
                this._footerFinished = null;
                this._header = null;
                this._pageTitle = null;
                this._fullUsername = null;
                this._leftHeader = null;
                this._rightHeader = null;
                this._enablePageTitleForLogon = null;
                this._aboutHtml = null;
                this._adminHtml = null;
                this._useSimpleSearch = null;
                this._useSimplePersonal = null;
                this._adminPage = null;
                this._currentAboutModalSession = null;
                this._currentAdminModalSession = null;
                this._currentChangePwModalSession = null;
                this._currentBusyModalSession = null;
                this._changePwHtml = null;
                this._processingDiv = null;
                this._oldPasswordContainer = null;
                this._oldPasswordInput = null;
                this._newPasswordContainer = null;
                this._newPasswordInput = null;
                this._reenterPasswordContainer = null;
                this._reenterPasswordInput = null;
                this._changePwBtn = null;
                this._sideBarOpened = false;
                this._userSettingsHelper = null;
                this.startNavigation = () => {
                    this._log.info("MenuNavigationHandler.startNavigation()");
                    this._headerFinished = false;
                    this._menuFinished = false;
                    this._footerFinished = false;
                    // start loading HTML files
                    this._core.Loader.getVersionedHTML("assets/wpt/html/pageHeader.html", this._prepareHeader, this._core.Helper.missingHtmlErrorCallback);
                    this._core.Loader.getVersionedHTML("assets/wpt/html/sideMenu.html", this._prepareSideMenu, this._core.Helper.missingHtmlErrorCallback);
                    this._core.Loader.getVersionedHTML("assets/wpt/html/pageFooter.html", this._prepareFooter, this._core.Helper.missingHtmlErrorCallback);
                    // select elements for later use
                    this._loadingSite = document.getElementById('loadingSite');
                    this._logonPage = document.getElementById('logonPage');
                };
                this.updateApplications = (switchToLogoffApplication = false, switchToMappedApplication = false) => {
                    this._log.info("MenuNavigationHandler.updateApplications()");
                    let needsUpdate = this._core.Config.updateApplications(switchToLogoffApplication, switchToMappedApplication);
                    this._displayApplications();
                    return needsUpdate;
                };
                this.startLogonView = () => {
                    this._log.info("MenuNavigationHandler.startLogonView()");
                    this._prepareLogon();
                    this._nav.Logon.startNavigation();
                };
                this.startApplicationView = () => {
                    this._log.info("MenuNavigationHandler.startApplicationView()");
                    this._prepareApplicationView();
                    this._nav.Home.startNavigation();
                };
                this.showBottomHourGlass = () => {
                    this._log.info("MenuNavigationHandler.showBottomHourGlass()");
                    this._core.Functions.showElement(this._bottomHourGlass);
                };
                this.hideBottomHourGlass = () => {
                    this._log.info("MenuNavigationHandler.hideBottomHourGlass()");
                    this._core.Functions.hideElement(this._bottomHourGlass);
                };
                /**
                 * Prepare header navigation elements.
                 * @param html HTML for the page header
                 */
                this._prepareHeader = (html) => {
                    this._log.info("MenuNavigationHandler._prepareHeader()");
                    this._header = document.getElementById("pageHeader");
                    this._header.innerHTML = html;
                    // select elements for later use
                    this._leftHeader = this._header.querySelector('#leftHeader');
                    this._rightHeader = this._header.querySelector('#rightHeader');
                    this._headerLogo = this._leftHeader.querySelector('#headerLogo');
                    this._loginIcons = this._rightHeader.querySelector('#loginIcons');
                    this._navigationIcons = this._rightHeader.querySelector('#navigationIcons');
                    this.HomeButton = this._navigationIcons.querySelector('#homeButton');
                    this._pageTitle = this._header.querySelector('#pageTitle');
                    this._fullUsername = this._navigationIcons.querySelector('#fullUserIdentifier');
                    this._core.Helper.setElementTranslationAttribute(this._loginIcons.querySelector('#loginButton'), 'title', 'STR_WPT_SIGN_IN');
                    // add event listener
                    this._rightHeader.querySelector("#openCloseNav").addEventListener("click", this._openSidebar);
                    this._fullUsername.addEventListener('click', this._userClicked);
                    this._navigationIcons.querySelector('#miniUserIdentifier').addEventListener('click', this._userClicked);
                    this.HomeButton.addEventListener('click', this._backToHomepage);
                    this._navigationIcons.querySelector('#logoffButton').addEventListener('click', this._doLogoff);
                    this._loginIcons.querySelector('#loginButton').addEventListener('click', this._doLogin);
                    // check configuration
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('Content') && appConfig.Content.hasOwnProperty('PageTitle') && appConfig.Content.PageTitle.length > 0) {
                        this._core.Helper.setElementTranslation(this._pageTitle, appConfig.Content.PageTitle);
                    }
                    this._headerFinished = true;
                    // calculate
                    this._calcHeaderWidth();
                    this._finishing();
                };
                /**
                 * Prepare side menu.
                 * @param html HTML for side menu
                 */
                this._prepareSideMenu = (html) => {
                    this._log.info("MenuNavigationHandler._prepareSideMenu()");
                    let container = document.getElementById("sideMenu");
                    container.innerHTML = html;
                    let mainConfig = this._core.Config.getMainConfig();
                    let appConfig = this._core.Config.getApplicationConfig();
                    // default is no custom nav options
                    this._customNavOptions = [];
                    if (appConfig.hasOwnProperty("Layout") && appConfig.Layout.hasOwnProperty("CustomNavOptions")) {
                        this._customNavOptions = appConfig.Layout.CustomNavOptions;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using custom navigation options: " + JSON.stringify(this._customNavOptions));
                        }
                    }
                    // default is structured display of searches
                    this._useSimpleSearch = false;
                    // looking for configuration option to use simpler display style for searches
                    if (appConfig.hasOwnProperty("Layout") && appConfig.Layout.hasOwnProperty("DisplaySearchSimple")) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using simple search display value from application configuration");
                        }
                        this._useSimpleSearch = appConfig.Layout.DisplaySearchSimple;
                    }
                    else if (mainConfig.hasOwnProperty("DisplaySearchSimple")) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using simple search display value from config.json");
                        }
                        this._useSimpleSearch = mainConfig.DisplaySearchSimple;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("using simple search display value: " + this._useSimpleSearch);
                    }
                    // default is structured display of personal data
                    this._useSimplePersonal = false;
                    // looking for configuration option to use simpler display style for personal data
                    if (appConfig.hasOwnProperty("Layout") && appConfig.Layout.hasOwnProperty("DisplayPersonalSimple")) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using simple personal display value from application configuration");
                        }
                        this._useSimplePersonal = appConfig.Layout.DisplayPersonalSimple;
                    }
                    else if (mainConfig.hasOwnProperty("DisplayPersonalSimple")) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using simple personal display value from config.json");
                        }
                        this._useSimplePersonal = mainConfig.DisplayPersonalSimple;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("using simple personal display value: " + this._useSimplePersonal);
                    }
                    // select elements for later use
                    this._sideNav = container.querySelector("#sidenav");
                    this._sideNavList = container.querySelector('#sidenav-list');
                    this._customMarker = container.querySelector('#CUSTOMSIDEMENUENTRYMARKER');
                    this._coverMe = container.querySelector("#coverMe");
                    this._applicationOptions = container.querySelector("#applicationOptions");
                    this._applicationList = container.querySelector("#applicationList");
                    this._applicationOverflow = container.querySelector("#applicationOverflow");
                    this._languageOptions = container.querySelector("#langOptions");
                    this._languageList = container.querySelector("#langList");
                    this._languageOverflow = container.querySelector("#langOverflow");
                    this._themeOptions = container.querySelector("#themeOptions");
                    this._themeList = container.querySelector("#themeList");
                    this._themeOverflow = container.querySelector("#themeOverflow");
                    this._logOff = container.querySelector("#LblSideLogOff");
                    this._logIn = container.querySelector('#LblSideLogIn');
                    this._about = container.querySelector("#LblSideAbout");
                    this._adminPage = container.querySelector('#LblSideAdmin');
                    this._searchList = container.querySelector('#LblSideDocSearchesTypes').parentElement;
                    this._search = container.querySelector('#LblSideCustomQuery');
                    this._advSearch = container.querySelector('#LblSideDocRetrieval');
                    if (this._useSimpleSearch) {
                        this._core.Functions.hideElement(this._searchList);
                        this._search = container.querySelector('#LblSideCustomQuerySimple');
                        this._advSearch = container.querySelector('#LblSideDocRetrievalSimple');
                    }
                    this._upload = container.querySelector('#LblSideUpload');
                    this._workflow = container.querySelector('#LblSideWorkflow');
                    this._forms = container.querySelector('#LblForms');
                    this._personalList = container.querySelector('#LblSidePersonal').parentElement;
                    this._myFolders = container.querySelector('#LblMyFolders');
                    this._myDocuments = container.querySelector('#LblMyDocuments');
                    this._savedSearch = container.querySelector('#LblSideSavedSearches');
                    if (this._useSimplePersonal) {
                        this._core.Functions.hideElement(this._personalList);
                        this._myFolders = container.querySelector('#LblMyFoldersSimple');
                        this._myDocuments = container.querySelector('#LblMyDocumentsSimple');
                        this._savedSearch = container.querySelector('#LblSideSavedSearchesSimple');
                    }
                    this._changePw = container.querySelector('#LblSideChangePw');
                    this._forgotPw = container.querySelector('#LblSideForgotPw');
                    this._myProfile = container.querySelector('#LblSideMyProfile');
                    // event listener for side menu items
                    container.querySelector("#closeNav").addEventListener("click", this._closeSidebar);
                    this._searchList.addEventListener("click", this._searchListClicked);
                    this._search.addEventListener('click', this._showSearchPage);
                    this._advSearch.addEventListener('click', this._showAdvSearchPage);
                    this._upload.addEventListener('click', this._showUploadPage);
                    this._workflow.addEventListener('click', this._showWorkflowPage);
                    this._forms.addEventListener('click', this._showFormsPage);
                    this._personalList.addEventListener('click', this._personalListClicked);
                    this._myFolders.addEventListener('click', this._showEnvelopesPage);
                    this._myDocuments.addEventListener('click', this._showPersonalDocsPage);
                    this._savedSearch.addEventListener('click', this._showSavedSearchPage);
                    this._about.addEventListener("click", this._showAbout);
                    this._forgotPw.addEventListener('click', this._showForgotPw);
                    this._changePw.addEventListener('click', this._showChangePwWithClose);
                    this._myProfile.addEventListener('click', this._showUserSettingsWithClose);
                    this._adminPage.addEventListener('click', this._showAdminPage);
                    this._logOff.addEventListener('click', this._doLogoff);
                    this._logIn.addEventListener('click', this._doLogin);
                    // start logic
                    this._displayLanguages();
                    this._displayApplications();
                    this._displayThemes();
                    this._setTranslations();
                    this._addCustomNavOptions();
                    this._finishSideMenu();
                };
                /**
                 * Prepare footer navigation elements.
                 * @param htmlData HTML for footer navigation elements
                 */
                this._prepareFooter = (htmlData) => {
                    this._log.info("MenuNavigationHandler._prepareFooter()");
                    this._footer = document.getElementById("pageFooter");
                    this._footer.innerHTML = htmlData;
                    // select element for later use
                    this._bottomHourGlass = this._footer.querySelector('#footerHourGlass');
                    this._core.Helper.prepareHourglassIcon(this._footer);
                    // hide footer for small devices (not enough space to waste it)
                    this._calcFooter();
                    let appConfig = this._core.Config.getApplicationConfig();
                    // hide poweredBy button only if explicitely configured (not documented on purpose)
                    if (appConfig.hasOwnProperty('HidePoweredByHyland') && appConfig.HidePoweredByHyland === true) {
                        this._core.Functions.hideElement(this._footer.querySelector('#poweredBy'));
                    }
                    this._footerFinished = true;
                    this._finishing();
                };
                this.windowResized = () => {
                    this._log.info("MenuNavigationHandler.windowResized()");
                    this._calcFooter();
                    this._calcHeaderWidth();
                };
                this._calcFooter = () => {
                    this._log.info("MenuNavigationHandler._calcFooter()");
                    if (!this._footerFinished)
                        return;
                    // hide footer for small devices (not enough space to waste it)
                    if (this._core.Helper.isSmallDevice()) {
                        this._core.Functions.hideElement(this._footer);
                    }
                    else if (!this._sideBarOpened) {
                        this._core.Functions.showElement(this._footer);
                    }
                };
                this._finishing = () => {
                    this._log.info("MenuNavigationHandler._finishing()");
                    if (this._headerFinished && this._menuFinished && this._footerFinished) {
                        this._startView();
                    }
                };
                this._calcHeaderWidth = () => {
                    this._log.info("MenuNavigationHandler.calcHeaderWidth()");
                    if (!this._headerFinished)
                        return;
                    this._core.Functions.showElement(this._fullUsername);
                    if (this._enablePageTitleForLogon === null) {
                        let appConfig = this._core.Config.getApplicationConfig();
                        if (appConfig.hasOwnProperty('Content') && appConfig.Content != null && appConfig.Content.hasOwnProperty('EnablePageTitleForLogon') && appConfig.Content.EnablePageTitleForLogon != null) {
                            this._enablePageTitleForLogon = appConfig.Content.EnablePageTitleForLogon;
                        }
                        else {
                            this._enablePageTitleForLogon = false;
                        }
                    }
                    if (!this._core.isUserLoggedIn() && !this._enablePageTitleForLogon) {
                        this._core.Functions.hideElement(this._pageTitle);
                    }
                    else {
                        this._core.Functions.showElement(this._pageTitle);
                    }
                    // TODO: the changes may need time before the size can be calculated properly, look for a proper way to do it
                    window.setTimeout(this._finishCalcHeaderWidth, this._core.getSleepTime());
                };
                this._finishCalcHeaderWidth = () => {
                    this._log.info("MenuNavigationHandler._finishCalcHeaderWidth()");
                    let headerWidth = this._core.Functions.getCompleteElementWidth(this._header);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("starting with header width: " + headerWidth);
                    }
                    let leftHeaderWidth = this._core.Functions.getCompleteElementWidth(this._leftHeader);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("left header width: " + leftHeaderWidth);
                    }
                    let rightHeaderWidth = this._rightHeader.offsetWidth;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("right header width: " + rightHeaderWidth);
                    }
                    let titleWidth = this._core.Functions.getCompleteElementWidth(this._pageTitle);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got title width: " + titleWidth);
                    }
                    let nameWidth = this._core.Functions.getCompleteElementWidth(this._fullUsername);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got name width: " + nameWidth);
                    }
                    let smallRightHeaderWidth = rightHeaderWidth - nameWidth;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("small right header width: " + smallRightHeaderWidth);
                    }
                    let halfHeaderWidth = headerWidth / 2;
                    let halfTitleWidth = titleWidth / 2;
                    let availableWidth = halfHeaderWidth - halfTitleWidth;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("available width: " + availableWidth);
                    }
                    if (availableWidth < leftHeaderWidth) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("available width less than left header...");
                        }
                        this._core.Functions.hideElement(this._pageTitle);
                        if (nameWidth > 0 && ((leftHeaderWidth + rightHeaderWidth) > headerWidth)) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("left and right header to wide...");
                            }
                            this._core.Functions.hideElement(this._fullUsername);
                        }
                        if ((leftHeaderWidth + smallRightHeaderWidth) > headerWidth) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("left and small right header to wide...");
                            }
                            this._core.Functions.hideElement(this._leftHeader);
                        }
                    }
                    else if (availableWidth < rightHeaderWidth) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("available width less than right header...");
                        }
                        if (availableWidth > smallRightHeaderWidth) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("removing name is enough...");
                            }
                            this._core.Functions.hideElement(this._fullUsername);
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("removing name isn't enough...");
                            }
                            this._core.Functions.hideElement(this._pageTitle);
                            if (nameWidth > 0 && ((leftHeaderWidth + rightHeaderWidth) > headerWidth)) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("left and right header to wide...");
                                }
                                this._core.Functions.hideElement(this._fullUsername);
                            }
                            if ((leftHeaderWidth + smallRightHeaderWidth) > headerWidth) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("left and small right header to wide...");
                                }
                                this._core.Functions.hideElement(this._leftHeader);
                            }
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("wide enough...");
                        }
                    }
                };
                /**
                 * Opens the side menu.
                 */
                this._openSidebar = () => {
                    this._log.info("MenuNavigationHandler._openSidebar()");
                    this._core.Functions.hideElement(this._footer);
                    this._sideNav.style.width = this._sideNavWidth;
                    this._coverMe.style.visibility = "visible";
                    this._sideBarOpened = true;
                };
                /**
                 * Closes the side menu.
                 */
                this._closeSidebar = () => {
                    this._log.info("MenuNavigationHandler._closeSidebar()");
                    if (!this._core.Helper.isSmallDevice()) {
                        this._core.Functions.showElement(this._footer);
                    }
                    this._sideNav.style.width = "0";
                    this._coverMe.style.visibility = "hidden";
                    this._sideBarOpened = false;
                };
                this._searchListClicked = () => {
                    this._log.info("MenuNavigationHandler._searchListClicked()");
                    this._searchList.classList.toggle(EXPAND_CLASS);
                };
                this._showSearchPage = () => {
                    this._log.info("MenuNavigationHandler._showSearchPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'CustomQuery';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showAdvSearchPage = () => {
                    this._log.info("MenuNavigationHandler._showAdvSearchPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'DocumentRetrieval';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showSavedSearchPage = () => {
                    this._log.info("MenuNavigationHandler._showSavedSearchPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'SavedSearches';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showFormsPage = () => {
                    this._log.info("MenuNavigationHandler._showFormsPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'FormView';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showUploadPage = () => {
                    this._log.info("MenuNavigationHandler._showUploadPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'Upload';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showWorkflowPage = () => {
                    this._log.info("MenuNavigationHandler._showWorkflowPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'Workflow';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._personalListClicked = () => {
                    this._log.info("MenuNavigationHandler._personalListClicked()");
                    this._personalList.classList.toggle(EXPAND_CLASS);
                };
                this._showEnvelopesPage = () => {
                    this._log.info("MenuNavigationHandler._showEnvelopesPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'Envelopes';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showPersonalDocsPage = () => {
                    this._log.info("MenuNavigationHandler._showPersonalDocsPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = 'PersonalDocuments';
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showCustomNavPage = (detailView) => {
                    this._log.info("MenuNavigationHandler._showCustomNavPage()");
                    this._closeSidebar();
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = detailView;
                    navEvent.ForceReload = true;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._showForgotPw = () => {
                    this._log.info("MenuNavigationHandler._showForgotPw()");
                    this._closeSidebar();
                    this._nav.Logon.presentForgotPwModal();
                };
                this._showChangePwWithClose = () => {
                    this._log.info("MenuNavigationHandler._showChangePwWithClose()");
                    this._closeSidebar();
                    this.showChangePw();
                };
                this.showChangePw = () => {
                    this._log.info("MenuNavigationHandler.showChangePw()");
                    let modalSession = 'change-pw-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentChangePwModalSession = modalSession;
                        if (this._changePwHtml === null) {
                            this._core.Loader.getVersionedHTML("assets/wpt/html/changePassword.html", this._storeChangePwHtml, this._core.Helper.missingHtmlErrorCallback);
                        }
                        else {
                            this._presentChangePw();
                        }
                    }
                    else {
                        console.error("unable to show change password modal, modal placeholder is already used");
                    }
                };
                this._storeChangePwHtml = (htmlData) => {
                    this._log.info("MenuNavigationHandler._storeChangePwHtml()");
                    this._changePwHtml = htmlData;
                    this._presentChangePw();
                };
                this._presentChangePw = () => {
                    var _a, _b, _c;
                    this._log.info("MenuNavigationHandler._presentChangePw()");
                    let modal = this._core.getModal(this._currentChangePwModalSession);
                    modal.DIV.innerHTML = this._changePwHtml;
                    this._processingDiv = modal.DIV.querySelector('.wpt-hourglass');
                    this._oldPasswordContainer = modal.DIV.querySelector('#oldChangePasswordTextboxContainer');
                    this._oldPasswordInput = this._oldPasswordContainer.querySelector('#oldChangePasswordTextbox');
                    this._newPasswordContainer = modal.DIV.querySelector('#changePasswordTextboxContainer');
                    this._newPasswordInput = this._newPasswordContainer.querySelector('#changePasswordTextbox');
                    this._reenterPasswordContainer = modal.DIV.querySelector('#reenterChangePasswordTextboxContainer');
                    this._reenterPasswordInput = this._reenterPasswordContainer.querySelector('#reenterChangePasswordTextbox');
                    this._changePwBtn = modal.DIV.querySelector('#changePwButton');
                    this._core.Helper.prepareHourglassIcon(this._processingDiv);
                    this._core.Helper.setElementTranslationAttribute(this._oldPasswordInput, 'placeholder', 'STR_WPT_ENTEROLDPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._oldPasswordInput, 'aria-label', 'STR_WPT_ENTEROLDPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._newPasswordInput, 'placeholder', 'STR_WPT_ENTERNEWPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._newPasswordInput, 'aria-label', 'STR_WPT_ENTERNEWPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._reenterPasswordInput, 'placeholder', 'STR_WPT_REENTERNEWPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._reenterPasswordInput, 'aria-label', 'STR_WPT_REENTERNEWPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'title', "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'aria-label', "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#changePwModalTitle'), 'STR_WPT_CHANGEPASSWORD');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#changePwButtonLabel'), 'STR_WPT_CHANGEPASSWORD');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#processingLabel'), "STR_WPT_PROCESSING");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (((_a = appConfig.Content) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('PasswordInfoText')) && ((_b = appConfig.Content) === null || _b === void 0 ? void 0 : _b.PasswordInfoText.length) > 0) {
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#changePwInfoText'), (_c = appConfig.Content) === null || _c === void 0 ? void 0 : _c.PasswordInfoText);
                        this._core.Functions.showElement(modal.DIV.querySelector('#changePwInfoTextDiv'));
                    }
                    this._changePwBtn.addEventListener('click', this._changePassword);
                    this._oldPasswordInput.addEventListener('keyup', this._changePwKeyup);
                    this._newPasswordInput.addEventListener('keyup', this._changePwKeyup);
                    this._reenterPasswordInput.addEventListener('keyup', this._changePwKeyup);
                    modal.DIV.querySelector('#oldChangePasswordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._oldPasswordInput));
                    modal.DIV.querySelector('#changePasswordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._newPasswordInput));
                    modal.DIV.querySelector('#reenterChangePasswordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._reenterPasswordInput));
                    this._showChangePwModal();
                };
                this._showChangePwModal = () => {
                    this._log.info("MenuNavigationHandler._showChangePwModal()");
                    let menu = this;
                    let modal = this._core.getModal(this._currentChangePwModalSession);
                    modal.JQ.one('shown.bs.modal', function () {
                        menu._oldPasswordInput.focus();
                    });
                    this._oldPasswordInput.focus();
                    this._core.showModal(this._currentChangePwModalSession);
                };
                this._changePwKeyup = (event) => {
                    this._log.info("MenuNavigationHandler._changePwKeyup()");
                    if (event.key === "Enter") {
                        this._changePassword();
                    }
                };
                this._changePassword = (event = null) => {
                    this._log.info("MenuNavigationHandler._changePassword()");
                    if (event)
                        event.preventDefault(); // prevent sending of form (would reload the page)
                    let oldPassword = this._oldPasswordInput.value;
                    let newPassword = this._newPasswordInput.value;
                    let reenterPwd = this._reenterPasswordInput.value;
                    if (oldPassword === '') {
                        this._oldPasswordInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._oldPasswordInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (newPassword === '') {
                        this._newPasswordInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._newPasswordInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (reenterPwd === '') {
                        this._reenterPasswordInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._reenterPasswordInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (oldPassword != '' && newPassword != '' && reenterPwd != '' && newPassword === reenterPwd) {
                        this._newPasswordInput.classList.remove(Navigation.REQUIRED_CLASS);
                        this._reenterPasswordInput.classList.remove(Navigation.REQUIRED_CLASS);
                        this._prepareChangePwInput(false);
                        this._core.Functions.showElement(this._processingDiv);
                        let user = {
                            Password: oldPassword,
                            NewPassword: newPassword,
                            Username: this._core.getCurrentUsername(),
                            UserGroups: []
                        };
                        this._core.Loader.genericServiceCallWithData('/User.svc/rest/ChangePassword', JSON.stringify(user), this._successfulPwChange, null, this._changePwError, this._changePwFailed, true);
                    }
                    else if (newPassword !== reenterPwd) {
                        console.warn("password needs to be provided two times and they have to match");
                        this._newPasswordInput.classList.add(Navigation.REQUIRED_CLASS);
                        this._reenterPasswordInput.classList.add(Navigation.REQUIRED_CLASS);
                        this._core.Helper.presentWarningModal("STR_WPT_PASSWORDS_NOT_MATCHING");
                    }
                };
                this._prepareChangePwInput = (enable) => {
                    this._log.info("MenuNavigationHandler._prepareChangePwInput()");
                    this._core.Functions.setInputAbility(this._oldPasswordContainer, enable);
                    this._core.Functions.setInputAbility(this._newPasswordContainer, enable);
                    this._core.Functions.setInputAbility(this._reenterPasswordContainer, enable);
                    if (enable) {
                        this._changePwBtn.classList.remove(Navigation.DISABLED_CLASS);
                        this._changePwBtn.addEventListener('click', this._changePassword);
                        this._oldPasswordInput.addEventListener('keyup', this._changePwKeyup);
                        this._newPasswordInput.addEventListener('keyup', this._changePwKeyup);
                        this._reenterPasswordInput.addEventListener('keyup', this._changePwKeyup);
                    }
                    else {
                        this._changePwBtn.classList.add(Navigation.DISABLED_CLASS);
                        this._changePwBtn.removeEventListener('click', this._changePassword);
                        this._oldPasswordInput.removeEventListener('keyup', this._changePwKeyup);
                        this._newPasswordInput.removeEventListener('keyup', this._changePwKeyup);
                        this._reenterPasswordInput.removeEventListener('keyup', this._changePwKeyup);
                    }
                };
                this._successfulPwChange = (response) => {
                    this._log.info("MenuNavigationHandler._successfulPwChange()");
                    this._core.Functions.hideElement(this._processingDiv);
                    this._core.Functions.clearInputElement(this._oldPasswordInput);
                    this._core.Functions.clearInputElement(this._newPasswordInput);
                    this._core.Functions.clearInputElement(this._reenterPasswordInput);
                    let menu = this;
                    let modal = menu._core.getModal(menu._currentChangePwModalSession);
                    modal.JQ.one('hidden.bs.modal', function () {
                        menu._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_UPDATEDPASSWORD');
                    });
                    this._core.hideModal(menu._currentChangePwModalSession);
                };
                this._changePwError = (url, status, text) => {
                    this._log.info("MenuNavigationHandler._changePwError()");
                    this._core.Functions.hideElement(this._processingDiv);
                    this._prepareChangePwInput(true);
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_UNABLETOUPDATEPASSWORD');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CHANGEPASSWORD", "STR_WPT_ERROR", msgBody);
                };
                this._changePwFailed = (response) => {
                    this._log.info("MenuNavigationHandler._changePwFailed()");
                    this._core.Functions.hideElement(this._processingDiv);
                    this._prepareChangePwInput(true);
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_UNABLETOUPDATEPASSWORD');
                    let msgBody = msgPrefix;
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        msgBody += " " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(msgBody);
                };
                this._showUserSettingsWithClose = () => {
                    this._log.info("MenuNavigationHandler._showUserSettingsWithClose()");
                    this._closeSidebar();
                    if (!this._userSettingsHelper)
                        this._userSettingsHelper = new WPTNamespace.Utilities.UserSettingsHelper(this._core);
                    this._userSettingsHelper.showSettingsDialog();
                };
                this._showUserSettings = () => {
                    this._log.info("MenuNavigationHandler._showUserSettings()");
                    if (!this._userSettingsHelper)
                        this._userSettingsHelper = new WPTNamespace.Utilities.UserSettingsHelper(this._core);
                    this._userSettingsHelper.showSettingsDialog();
                };
                this._showAbout = () => {
                    this._log.info("MenuNavigationHandler._showAbout()");
                    this._closeSidebar();
                    let modalSession = 'about-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentAboutModalSession = modalSession;
                        if (this._aboutHtml === null) {
                            this._core.Loader.getVersionedHTML("assets/wpt/html/aboutModal.html", this._storeAboutHtml, this._core.Helper.missingHtmlErrorCallback);
                        }
                        else {
                            this._presentAbout();
                        }
                    }
                    else {
                        console.error("unable to show about modal, modal placeholder is already used");
                    }
                };
                this._storeAboutHtml = (htmlData) => {
                    this._log.info("MenuNavigationHandler._storeAboutHtml()");
                    this._aboutHtml = htmlData;
                    this._presentAbout();
                };
                this._presentAbout = () => {
                    this._log.info("MenuNavigationHandler._presentAbout()");
                    let modal = this._core.getModal(this._currentAboutModalSession);
                    modal.DIV.innerHTML = this._aboutHtml;
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#aboutModalTitle'), "STR_WPT_ABOUT");
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#aboutCloseButtonLabel'), "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#aboutCloseButtonLabel'), 'title', "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#aboutCloseIcon'), 'aria-label', "STR_WPT_CLOSE");
                    this._fillAboutDetails(modal.DIV);
                    this._core.showModal(this._currentAboutModalSession);
                };
                this._fillAboutDetails = (element) => {
                    this._log.info("MenuNavigationHandler._fillAboutDetails()");
                    let server = this._core.getServer();
                    if (server !== null) {
                        let serverSpan = element.querySelector('#serverValue');
                        serverSpan.innerHTML = '';
                        let link = document.createElement('a');
                        link.textContent = server;
                        link.href = server;
                        link.target = '_blank';
                        link.rel = 'noopener noreferrer';
                        serverSpan.appendChild(link);
                    }
                    let validServer = this._core.getValidServer();
                    if (validServer !== null)
                        element.querySelector('#validServerValue').textContent = validServer;
                    let connection = this._core.getCurrentConnection();
                    if (connection !== null) {
                        element.querySelector('#serviceVersionValue').textContent = connection.Version;
                        element.querySelector('#onbaseVersionValue').textContent = connection.OnBaseVersion;
                        element.querySelector('#isConnectedValue').textContent = connection.IsConnected.toString();
                        if (connection.IsConnected) {
                            let userInformation = element.querySelector('#userInformation');
                            userInformation.classList.remove(WPTNamespace.HIDDEN_CLASS);
                            let loginTime = this._core.getLoginTime();
                            if (loginTime !== null) {
                                element.querySelector('#loggedOnAtValue').textContent = this._core.Locale.DatetimeFormatter.format(loginTime);
                            }
                            let user = this._core.getCurrentUser();
                            if (user !== null) {
                                element.querySelector('#usernameValue').textContent = user.Username;
                                element.querySelector('#fullnameValue').textContent = user.Fullname;
                                element.querySelector('#emailValue').textContent = user.Email;
                            }
                        }
                    }
                };
                this._showAdminPage = () => {
                    this._log.info("MenuNavigationHandler._showAdminPage()");
                    this._closeSidebar();
                    let modalSession = 'admin-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentAdminModalSession = modalSession;
                        if (this._adminHtml === null) {
                            this._core.Loader.getVersionedHTML("assets/wpt/html/adminModal.html", this._storeAdminHtml, this._core.Helper.missingHtmlErrorCallback);
                        }
                        else {
                            this._presentAdminPage();
                        }
                    }
                    else {
                        console.error("unable to show admin modal, modal placeholder is already used");
                    }
                };
                this._storeAdminHtml = (htmlData) => {
                    this._log.info("MenuNavigationHandler._storeAdminHtml()");
                    this._adminHtml = htmlData;
                    this._presentAdminPage();
                };
                this._presentAdminPage = () => {
                    this._log.info("MenuNavigationHandler._presentAdminPage()");
                    let modal = this._core.getModal(this._currentAdminModalSession);
                    modal.DIV.innerHTML = this._adminHtml;
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#adminModalTitle'), "STR_WPT_ADMIN_PAGE");
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#adminCloseButtonLabel'), "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#adminCloseButtonLabel'), 'title', "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#adminCloseIcon'), 'aria-label', "STR_WPT_CLOSE");
                    this._fillAdminDetails(modal.DIV);
                    this._core.showModal(this._currentAdminModalSession);
                };
                this._fillAdminDetails = (element) => {
                    this._log.info("MenuNavigationHandler._fillAdminDetails()");
                    let slReloadBtn = element.querySelector('#slConfigReloadButton');
                    let slLogReloadBtn = element.querySelector('#slLogConfigReloadButton');
                    let slLogDownloadBtn = element.querySelector('#slLogConfigDownloadButton');
                    this._core.Helper.setElementTranslation(slReloadBtn.querySelector('#slConfigReloadButtonLabel'), "STR_WPT_REFRESH");
                    this._core.Helper.setElementTranslation(slLogReloadBtn.querySelector('#slLogConfigReloadButtonLabel'), "STR_WPT_REFRESH");
                    this._core.Helper.setElementTranslation(slLogDownloadBtn.querySelector('#slLogConfigDownloadButtonLabel'), "STR_WPT_LOG_DOWNLOAD");
                    slReloadBtn.addEventListener('click', this._adminReloadSlConfig);
                    slLogReloadBtn.addEventListener('click', this._adminReloadSlLogConfig);
                    slLogDownloadBtn.addEventListener('click', this._adminDownloadSlLog);
                };
                this._adminReloadSlConfig = () => {
                    this._log.info("MenuNavigationHandler._adminReloadSlConfig()");
                    let modalSession = 'reload-sl-config-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.SECOND, modalSession, "STR_WPT_PROCESSING")) {
                        this._currentBusyModalSession = modalSession;
                    }
                    this._core.Loader.genericServiceCall('/PortalConfig.svc/rest/ReloadServiceLayerConfig', this._closeBusyModal, this._adminReloadSlConfigError, this._adminReloadSlConfigFailed);
                };
                this._adminReloadSlConfigError = (url, status, text) => {
                    this._log.info("MenuNavigationHandler._adminReloadSlConfigError()");
                    this._closeBusyModal();
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_RELOAD_SL_CONFIG_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_RELOAD_SL_CONFIG", "STR_WPT_ERROR", msgBody);
                };
                this._adminReloadSlConfigFailed = (response) => {
                    this._log.info("MenuNavigationHandler._adminReloadSlConfigFailed()");
                    this._closeBusyModal();
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_RELOAD_SL_CONFIG_ERROR_MSG');
                    let errorMsg = msgPrefix + ": ";
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        errorMsg += response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._adminReloadSlLogConfig = () => {
                    this._log.info("MenuNavigationHandler._adminReloadSlLogConfig()");
                    let modalSession = 'reload-log-config-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.SECOND, modalSession, "STR_WPT_PROCESSING")) {
                        this._currentBusyModalSession = modalSession;
                    }
                    this._core.Loader.genericServiceCall('/PortalConfig.svc/rest/ReloadLogConfig', this._closeBusyModal, this._adminReloadSlLogConfigError, this._adminReloadSlLogConfigFailed);
                };
                this._adminReloadSlLogConfigError = (url, status, text) => {
                    this._log.info("MenuNavigationHandler._adminReloadSlLogConfigError()");
                    this._closeBusyModal();
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_RELOAD_LOG_CONFIG_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_RELOAD_LOG_CONFIG", "STR_WPT_ERROR", msgBody);
                };
                this._adminReloadSlLogConfigFailed = (response) => {
                    this._log.info("MenuNavigationHandler._adminReloadSlLogConfigFailed()");
                    this._closeBusyModal();
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_RELOAD_LOG_CONFIG_ERROR_MSG');
                    let errorMsg = msgPrefix + ": ";
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        errorMsg += response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._adminDownloadSlLog = () => {
                    this._log.info("MenuNavigationHandler._adminDownloadSlLog()");
                    let modalSession = 'download-log-file-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.SECOND, modalSession, "STR_WPT_PROCESSING")) {
                        this._currentBusyModalSession = modalSession;
                    }
                    this._core.Loader.genericServiceCallRawData('/GetLogFile.ashx', this._adminSlLogDownloaded, this._adminDownloadSlLogError);
                };
                this._adminDownloadSlLogError = () => {
                    this._log.info("MenuNavigationHandler._adminDownloadSlLogError()");
                    this._closeBusyModal();
                    let msg = this._core.Locale.getTranslation("STR_WPT_LOG_DOWNLOAD_FAILED_MSG");
                    console.warn(msg);
                    this._core.Helper.presentWarningModal(msg);
                };
                this._adminSlLogDownloaded = (rawResponse) => {
                    this._log.info("MenuNavigationHandler._adminSlLogDownloaded()");
                    this._closeBusyModal();
                    let objectURL = window.URL.createObjectURL(new Blob([rawResponse.ContentRaw]));
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created object URL: " + objectURL);
                    }
                    let tempAnchor = document.createElement('a');
                    tempAnchor.href = objectURL;
                    tempAnchor.download = rawResponse.ContentName;
                    document.body.appendChild(tempAnchor);
                    tempAnchor.click();
                    document.body.removeChild(tempAnchor);
                    window.URL.revokeObjectURL(objectURL);
                };
                this._closeBusyModal = () => {
                    this._log.info("MenuNavigationHandler._closeBusyModal()");
                    if (this._currentBusyModalSession) {
                        this._core.Helper.closeBusyModal(this._currentBusyModalSession);
                        this._currentBusyModalSession = null;
                    }
                };
                this._doLogoff = () => {
                    this._log.info("MenuNavigationHandler._doLogoff()");
                    this._closeSidebar();
                    this._core.logoff();
                };
                this._doLogin = () => {
                    this._log.info("MenuNavigationHandler._doLogin()");
                    this._closeSidebar();
                    this._nav.Logon.presentLogonModal();
                };
                /**
                 * Display languages/locales in side menu.
                 */
                this._displayLanguages = () => {
                    this._log.info("MenuNavigationHandler._displayLanguages()");
                    let languages = this._core.Locale.getVisibleLanguages();
                    let selectedLang = this._core.Locale.getSelectedLocale();
                    let mainConfig = this._core.Config.getMainConfig();
                    let appConfig = this._core.Config.getApplicationConfig();
                    this._languageOptions.addEventListener("click", this._langOptionsClicked);
                    this._languageList.innerHTML = "";
                    // default is structured display of languages
                    let useSimpleDisplay = false;
                    // looking for configuration option to use simpler display style for languages
                    if (appConfig.hasOwnProperty("Layout") && appConfig.Layout.hasOwnProperty("DisplayLangSimple")) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using simple lang display value from application configuration");
                        }
                        useSimpleDisplay = appConfig.Layout.DisplayLangSimple;
                    }
                    else if (mainConfig.hasOwnProperty("DisplayLangSimple")) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using simple lang display value from config.json");
                        }
                        useSimpleDisplay = mainConfig.DisplayLangSimple;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("using simple lang display value: " + useSimpleDisplay);
                    }
                    let nav = this;
                    let localeList = null;
                    // loop over languages
                    languages.forEach(function (language) {
                        if (!useSimpleDisplay) {
                            // create element for major language, if not using simple display style
                            let element = document.createElement('li');
                            element.classList.add(SUBITEM1_CLASS);
                            // emphasise currently selected language
                            if (selectedLang.LocaleCode.startsWith(language.LangCode)) {
                                element.classList.add(SUBITEM1_SELECTED_CLASS);
                            }
                            let langName = document.createTextNode(language.Name);
                            element.appendChild(langName);
                            element.addEventListener('click', nav._languageClicked);
                            nav._languageList.appendChild(element);
                            localeList = document.createElement('ul');
                            nav._core.Functions.hideElement(localeList);
                            element.appendChild(localeList);
                        }
                        // loop over subcategories like regions
                        language.Subcategories.forEach(function (locale) {
                            // create element for locale
                            let localeItem = document.createElement('li');
                            localeItem.setAttribute('data-locale', locale.LocaleCode);
                            // emphasise currently selected locale
                            if (locale.LocaleCode === selectedLang.LocaleCode) {
                                let span = document.createElement('span');
                                span.classList.add(...TICK_CLASSES);
                                localeItem.appendChild(span);
                            }
                            let localeName = document.createTextNode(locale.Name);
                            localeItem.appendChild(localeName);
                            localeItem.addEventListener('click', nav._localeSelected);
                            // append locale element depending on display style
                            if (useSimpleDisplay) {
                                localeItem.classList.add(SUBITEM1_CLASS);
                                if (locale.LocaleCode === selectedLang.LocaleCode) {
                                    localeItem.classList.add(SUBITEM1_SELECTED_CLASS);
                                }
                                nav._languageList.appendChild(localeItem);
                            }
                            else {
                                localeItem.classList.add(SUBITEM2_CLASS);
                                if (locale.LocaleCode === selectedLang.LocaleCode) {
                                    localeItem.classList.add(SUBITEM2_SELECTED_CLASS);
                                }
                                localeList.appendChild(localeItem);
                            }
                        });
                    });
                };
                /**
                 * Toggle visibility of language/locale list.
                 */
                this._langOptionsClicked = () => {
                    this._log.info("MenuNavigationHandler._langOptionsClicked()");
                    this._applicationOptions.classList.remove(EXPAND_CLASS);
                    this._core.Functions.hideElement(this._applicationOverflow);
                    this._themeOptions.classList.remove(EXPAND_CLASS);
                    this._core.Functions.hideElement(this._themeOverflow);
                    this._languageOptions.classList.toggle(EXPAND_CLASS);
                    if (this._languageList.clientHeight < this._languageList.scrollHeight) {
                        this._core.Functions.showElement(this._languageOverflow);
                    }
                    else {
                        this._core.Functions.hideElement(this._languageOverflow);
                    }
                };
                /**
                 * Toggle visibility of region list for major language.
                 * @param event event for the click on the major language in the side menu
                 */
                this._languageClicked = (event) => {
                    this._log.info("MenuNavigationHandler._languageClicked()");
                    // prevent event to bubble up the tree (would trigger _langOptionsClicked as well)
                    event.stopPropagation();
                    // get selected major language
                    let clickedItem = event.currentTarget;
                    let localeList = clickedItem.querySelector('ul');
                    localeList.classList.toggle(WPTNamespace.HIDDEN_CLASS);
                };
                /**
                 * Change the locale to the selected locale in the side menu.
                 * @param event event for the click on the locale in the side menu
                 */
                this._localeSelected = (event) => {
                    this._log.info("MenuNavigationHandler._localeSelected()");
                    // not preventing event to bubble up the tree (should trigger _languageClicked as well)
                    // get selected locale
                    let clickedItem = event.currentTarget;
                    let localeCode = clickedItem.getAttribute('data-locale');
                    this._closeSidebar();
                    this._languageOptions.classList.remove(EXPAND_CLASS);
                    this._core.Functions.hideElement(this._languageOverflow);
                    let localeFound = this._core.Locale.changeLocale(localeCode);
                    if (localeFound) {
                        this._displayLanguages();
                    }
                };
                /**
                 * Display applications in side menu.
                 */
                this._displayApplications = () => {
                    this._log.info("MenuNavigationHandler._displayApplications()");
                    let mainConfig = this._core.Config.getMainConfig();
                    let visibleApplications = this._core.Config.getVisibleApplications();
                    let selectedApplication = this._core.Config.getSelectedApplication();
                    if (mainConfig.hasOwnProperty("DisplayAllConfigsInMenu") && !mainConfig.DisplayAllConfigsInMenu) {
                        // hide if explicitely configured (default is to display applications)
                        this._core.Functions.hideElement(this._applicationOptions);
                    }
                    else {
                        this._core.Functions.showElement(this._applicationOptions);
                        this._applicationOptions.addEventListener("click", this._appOptionsClicked);
                        this._applicationList.innerHTML = "";
                        let menu = this;
                        // loop over the visible applications (visible to the current user, not the visible setting)
                        visibleApplications.forEach(function (app) {
                            // check visible setting first
                            if (app.hasOwnProperty('Visible') && app.Visible) {
                                let element = document.createElement('li');
                                element.classList.add(SUBITEM1_CLASS);
                                if (app.Name === "Break") {
                                    // break between groups of applications
                                    let hrLine = document.createElement('hr');
                                    element.appendChild(hrLine);
                                    element.classList.add(BREAK_CLASS);
                                }
                                else {
                                    element.setAttribute('data-application', app.Name);
                                    if (app.Name === selectedApplication.Name) {
                                        // the current application
                                        element.classList.add(SUBITEM1_SELECTED_CLASS);
                                        let span = document.createElement('span');
                                        span.classList.add(...TICK_CLASSES);
                                        element.appendChild(span);
                                    }
                                    let title = app.Name;
                                    if (app.hasOwnProperty('Desc') && app.Desc) {
                                        title = this._core.Locale.getTranslation(app.Desc);
                                    }
                                    let appTitle = document.createTextNode(title);
                                    element.appendChild(appTitle);
                                    element.addEventListener("click", menu._applicationSelected);
                                }
                                menu._applicationList.appendChild(element);
                            }
                        });
                    }
                };
                /**
                 * Toggle visibility of application list.
                 */
                this._appOptionsClicked = () => {
                    this._log.info("MenuNavigationHandler._appOptionsClicked()");
                    this._languageOptions.classList.remove(EXPAND_CLASS);
                    this._core.Functions.hideElement(this._languageOverflow);
                    this._themeOptions.classList.remove(EXPAND_CLASS);
                    this._core.Functions.hideElement(this._themeOverflow);
                    this._applicationOptions.classList.toggle(EXPAND_CLASS);
                    if (this._applicationList.clientHeight < this._applicationList.scrollHeight) {
                        this._core.Functions.showElement(this._applicationOverflow);
                    }
                    else {
                        this._core.Functions.hideElement(this._applicationOverflow);
                    }
                };
                /**
                 * Change the application to the selected application in the side menu.
                 * @param event event for the click on the application in the side menu
                 */
                this._applicationSelected = (event) => {
                    this._log.info("MenuNavigationHandler._applicationSelected()");
                    // not preventing event to bubble up the tree (should trigger _appOptionsClicked as well)
                    // get selected application
                    let clickedItem = event.currentTarget;
                    let appName = clickedItem.getAttribute('data-application');
                    this._closeSidebar();
                    let appFound = this._core.Config.changeApplication(appName);
                    if (appFound) {
                        this._displayApplications();
                    }
                };
                /**
                 * Display themes in side menu.
                 */
                this._displayThemes = () => {
                    this._log.info("MenuNavigationHandler._displayThemes()");
                    let mainConfig = this._core.Config.getMainConfig();
                    let availableThemes = this._core.Config.AvailableThemes;
                    let selectedApplication = this._core.Config.SelectedTheme;
                    if ((mainConfig.hasOwnProperty("DisplayAllConfigsInMenu") && !mainConfig.DisplayAllConfigsInMenu) || (availableThemes.length == 0)) {
                        // Hide if explicitly configured (default is to display themes)
                        this._core.Functions.hideElement(this._themeOptions);
                    }
                    else {
                        this._core.Functions.showElement(this._themeOptions);
                        this._themeOptions.addEventListener("click", this._themeOptionsClicked);
                        this._themeList.innerHTML = "";
                        let menu = this;
                        // loop over the visible applications (visible to the current user, not the visible setting)
                        availableThemes.forEach(theme => {
                            let element = document.createElement('li');
                            element.classList.add(SUBITEM1_CLASS);
                            // Allow breaks as we do for applications
                            if (theme.Name === "Break") {
                                // break between groups of applications
                                let hrLine = document.createElement('hr');
                                element.appendChild(hrLine);
                                element.classList.add(BREAK_CLASS);
                            }
                            else {
                                element.setAttribute('data-theme', theme.Name);
                                if (selectedApplication && (theme.Name === selectedApplication.Name)) {
                                    // the current application
                                    element.classList.add(SUBITEM1_SELECTED_CLASS);
                                    let span = document.createElement('span');
                                    span.classList.add(...TICK_CLASSES);
                                    element.appendChild(span);
                                }
                                let title = theme.Name;
                                if (theme.hasOwnProperty('Label') && theme.Label) {
                                    title = this._core.Locale.getTranslation(theme.Label);
                                }
                                let themeTitle = document.createTextNode(title);
                                element.appendChild(themeTitle);
                                if (theme.hasOwnProperty('Description') && theme.Description) {
                                    element.title = this._core.Locale.getTranslation(theme.Description);
                                }
                                element.addEventListener("click", menu._themeSelected);
                            }
                            menu._themeList.appendChild(element);
                        });
                    }
                };
                /**
                 * Toggle visibility of theme list.
                 */
                this._themeOptionsClicked = () => {
                    this._log.info("MenuNavigationHandler._themeOptionsClicked()");
                    this._applicationOptions.classList.remove(EXPAND_CLASS);
                    this._core.Functions.hideElement(this._applicationOverflow);
                    this._languageOptions.classList.remove(EXPAND_CLASS);
                    this._core.Functions.hideElement(this._languageOverflow);
                    this._themeOptions.classList.toggle(EXPAND_CLASS);
                    if (this._themeList.clientHeight < this._themeList.scrollHeight) {
                        this._core.Functions.showElement(this._themeOverflow);
                    }
                    else {
                        this._core.Functions.hideElement(this._themeOverflow);
                    }
                };
                /**
                 * Change the application to the selected application in the side menu.
                 * @param event event for the click on the application in the side menu
                 */
                this._themeSelected = (event) => {
                    this._log.info("MenuNavigationHandler._themeSelected()");
                    // not preventing event to bubble up the tree (should trigger _appOptionsClicked as well)
                    // get selected application
                    let clickedItem = event.currentTarget;
                    let themeName = clickedItem.getAttribute('data-theme');
                    this._closeSidebar();
                    let themeFound = this._core.Config.SelectTheme(themeName, true);
                    if (themeFound) {
                        this._displayThemes();
                    }
                };
                /**
                 * Translate the elements in the side menu.
                 */
                this._setTranslations = () => {
                    this._log.info("MenuNavigationHandler._setTranslations()");
                    this._core.Helper.setElementTranslation(this._searchList.querySelector('#LblSideDocSearchesTypes'), "STR_WPT_DOCSEARCHES");
                    this._core.Helper.setElementTranslation(this._search, "STR_WPT_CUSTOMQUERIES");
                    this._core.Helper.setElementTranslation(this._advSearch, "STR_WPT_DOCUMENTRETRIEVAL");
                    this._core.Helper.setElementTranslation(this._upload, "STR_WPT_UPLOAD");
                    this._core.Helper.setElementTranslation(this._workflow, "STR_WPT_WORKFLOW");
                    this._core.Helper.setElementTranslation(this._forms, "STR_WPT_FORMS");
                    this._core.Helper.setElementTranslation(this._personalList.querySelector('#LblSidePersonal'), "STR_WPT_PERSONALHEADING");
                    this._core.Helper.setElementTranslation(this._myFolders, "STR_WPT_MYFOLDERHEADING");
                    this._core.Helper.setElementTranslation(this._myDocuments, "STR_WPT_MYDOCSHEADING");
                    this._core.Helper.setElementTranslation(this._savedSearch, "STR_WPT_SAVED_SEARCHES");
                    this._core.Helper.setElementTranslation(this._about.querySelector('#lblNavAbout'), "STR_WPT_ABOUT");
                    this._core.Helper.setElementTranslation(this._adminPage.querySelector('#lblNavAdmin'), "STR_WPT_ADMIN_PAGE");
                    this._core.Helper.setElementTranslation(this._languageOptions.querySelector('#lblNavLang'), "STR_WPT_LANGUAGE");
                    this._core.Helper.setElementTranslation(this._logOff.querySelector('#lblNavLogOff'), "STR_WPT_LOGOFF");
                    this._core.Helper.setElementTranslation(this._logIn.querySelector('#lblNavLogIn'), "STR_WPT_SIGN_IN");
                    this._core.Helper.setElementTranslation(this._forgotPw, "STR_WPT_FORGOTPASSWORD");
                    this._core.Helper.setElementTranslation(this._changePw, "STR_WPT_CHANGEPASSWORD");
                    this._core.Helper.setElementTranslation(this._myProfile, "STR_WPT_MYPROFILE");
                    // look for custom translations of "STR_WPT_GATEWAY_APPLICATIONS", not part of lang files on purpose
                    let appTranslation = this._core.Locale.getTranslation("STR_WPT_GATEWAY_APPLICATIONS");
                    if (appTranslation === "STR_WPT_GATEWAY_APPLICATIONS") {
                        appTranslation = "Applications";
                    }
                    this._applicationOptions.querySelector("#lblNavApplications").innerHTML = appTranslation;
                };
                this._addCustomNavOptions = () => {
                    this._log.info("MenuNavigationHandler._addCustomNavOptions()");
                    let counter = 0;
                    this._customNavOptions.forEach(o => {
                        counter++;
                        let customItem = document.createElement('li');
                        customItem.id = "customItem-" + counter;
                        customItem.classList.add("menu-navigation__item");
                        if (o.WithSeparator) {
                            customItem.classList.add("menu-navigation__item--separated");
                        }
                        if (o.IconClasses) {
                            let iconSpan = document.createElement('span');
                            iconSpan.classList.add('menu-navigation__item-icon', ...o.IconClasses.split(" "));
                            customItem.appendChild(iconSpan);
                            customItem.appendChild(document.createTextNode("\t"));
                        }
                        let optionLabel = document.createTextNode(this._core.Locale.getTranslation(o.Title));
                        customItem.appendChild(optionLabel);
                        this._sideNavList.insertBefore(customItem, this._customMarker);
                        customItem.addEventListener('click', this._showCustomNavPage.bind(this, o.DetailView));
                    }, this);
                };
                /**
                 * Finishes the basic navigation elements and starts the actual navigation (go to login or homepage).
                 */
                this._finishSideMenu = () => {
                    this._log.info("MenuNavigationHandler._finishSideMenu()");
                    let appConfig = this._core.Config.getApplicationConfig();
                    // set width of the side menu, if configured
                    if (appConfig.hasOwnProperty('Layout') && appConfig.Layout.hasOwnProperty('SideNavWidth') && appConfig.Layout.SideNavWidth.length > 0) {
                        this._sideNavWidth = appConfig.Layout.SideNavWidth;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("set side nav width to: " + this._sideNavWidth);
                        }
                    }
                    this._menuFinished = true;
                    this._finishing();
                };
                this._startView = () => {
                    this._log.info("MenuNavigationHandler._startView()");
                    if (this._core.isUserLoggedIn()) {
                        this.startApplicationView();
                    }
                    else {
                        this.startLogonView();
                    }
                };
                this._prepareLogon = () => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("MenuNavigationHandler._prepareLogon()");
                    this._setNavOptionsVisibility(true);
                    this._core.Functions.hideElement(this._headerLogo);
                    this._core.Functions.hideElement(this._loadingSite);
                    this._core.Functions.hideElement(this._nav.Home.HomeView);
                    this._core.Functions.hideElement(this._nav.Details.DetailView);
                    this._core.Functions.showElement(this._logonPage);
                    this._core.Functions.hideElement(this._navigationIcons);
                    this._core.Functions.showElement(this._loginIcons);
                    // TODO: the changes above may need time before the height can be calculated properly, look for a proper way to do it
                    yield this._core.Functions.sleep(this._core.getSleepTime());
                    this._calcHeaderWidth();
                });
                this._prepareApplicationView = () => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("MenuNavigationHandler._prepareApplicationView()");
                    this._setNavOptionsVisibility(false);
                    this._core.Functions.hideElement(this._logonPage);
                    this._logonPage.innerHTML = "";
                    this._core.Functions.showElement(this._nav.Home.HomeView);
                    this._core.Functions.hideElement(this._nav.Details.DetailView);
                    let appConfig = this._core.Config.getApplicationConfig();
                    let headerLogoSrc = null;
                    if (appConfig.hasOwnProperty('Images') && appConfig.Images.hasOwnProperty('HeaderLogo')) {
                        headerLogoSrc = appConfig.Images.HeaderLogo;
                    }
                    if (appConfig.hasOwnProperty('SuppressHomeButton') && appConfig.SuppressHomeButton) {
                        this._core.Functions.hideElement(this._core.Navigation.Menu.HomeButton);
                    }
                    else
                        this._core.Functions.showElement(this._core.Navigation.Menu.HomeButton);
                    if (headerLogoSrc != null) {
                        this._headerLogo.src = headerLogoSrc;
                        this._core.Functions.showElement(this._headerLogo);
                    }
                    else {
                        this._core.Functions.hideElement(this._headerLogo);
                    }
                    this._fullUsername.innerHTML = UNKNOWN;
                    let user = this._core.getCurrentUser();
                    if (user != null && user.Fullname != undefined) {
                        let usernameLabelText = document.createTextNode(user.Fullname);
                        this._fullUsername.innerHTML = "";
                        this._fullUsername.appendChild(usernameLabelText);
                    }
                    this._core.Functions.hideElement(this._loginIcons);
                    this._core.Functions.showElement(this._navigationIcons);
                    // TODO: the changes above may need time before the height can be calculated properly, look for a proper way to do it
                    yield this._core.Functions.sleep(this._core.getSleepTime());
                    this._calcHeaderWidth();
                });
                this._setNavOptionsVisibility = (isLogon) => {
                    this._log.info("MenuNavigationHandler._setNavOptionsVisibility()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("is logon? " + isLogon);
                    }
                    let appConfig = this._core.Config.getApplicationConfig();
                    let navOptions = null;
                    if (appConfig.hasOwnProperty('Layout') && appConfig.Layout.hasOwnProperty('NavOptionVisible')) {
                        navOptions = JSON.parse(JSON.stringify(appConfig.Layout.NavOptionVisible));
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'NavOptionVisible' provided");
                        }
                        navOptions = {};
                    }
                    if (!navOptions.hasOwnProperty('Search')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'Search' provided");
                        }
                        navOptions.Search = true;
                    }
                    if (!navOptions.hasOwnProperty('AdvSearch')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'AdvSearch' provided");
                        }
                        navOptions.AdvSearch = true;
                    }
                    if (!navOptions.hasOwnProperty('Upload')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'Upload' provided");
                        }
                        navOptions.Upload = true;
                    }
                    if (!navOptions.hasOwnProperty('Workflow')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'Workflow' provided");
                        }
                        navOptions.Workflow = true;
                    }
                    if (!navOptions.hasOwnProperty('Forms')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'Forms' provided");
                        }
                        navOptions.Forms = true;
                    }
                    if (!navOptions.hasOwnProperty('MyFolders')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'MyFolders' provided");
                        }
                        navOptions.MyFolders = true;
                    }
                    if (!navOptions.hasOwnProperty('MyDocuments')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'MyDocuments' provided");
                        }
                        // default based on service capabilites
                        navOptions.MyDocuments = this._core.serviceAvailable('favourites') || this._core.serviceAvailable('recentdocuments');
                    }
                    if (!navOptions.hasOwnProperty('SavedSearches')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'SavedSearches' provided");
                        }
                        // default based on service capabilites
                        navOptions.SavedSearches = this._core.serviceAvailable('savedsearches');
                    }
                    if (!navOptions.hasOwnProperty('Lang')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'Lang' provided");
                        }
                        navOptions.Lang = true;
                    }
                    if (!navOptions.hasOwnProperty('ChangePw')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'ChangePw' provided");
                        }
                        navOptions.ChangePw = true;
                    }
                    if (!navOptions.hasOwnProperty('ForgotPw')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'ForgotPw' provided");
                        }
                        navOptions.ForgotPw = true;
                    }
                    if (!navOptions.hasOwnProperty('MyProfile')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no 'MyProfile' provided");
                        }
                        navOptions.MyProfile = true;
                    }
                    // default based on WPT Admin User group
                    let adminPageAllowed = false;
                    let user = this._core.getCurrentUser();
                    if (user && user.hasOwnProperty('IsWptAdmin') && user.IsWptAdmin == true) {
                        adminPageAllowed = true;
                    }
                    if (navOptions.hasOwnProperty('AdminPage')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("'AdminPage' provided");
                        }
                        if (navOptions.AdminPage == false) {
                            adminPageAllowed = false;
                        }
                    }
                    navOptions.AdminPage = adminPageAllowed;
                    let oneSearchVisible = navOptions.Search || navOptions.AdvSearch;
                    this._setNavOptionVisibleState(this._searchList, isLogon || this._useSimpleSearch ? false : oneSearchVisible);
                    this._setNavOptionVisibleState(this._search, isLogon ? false : navOptions.Search);
                    this._setNavOptionVisibleState(this._advSearch, isLogon ? false : navOptions.AdvSearch);
                    this._setNavOptionVisibleState(this._upload, isLogon ? false : navOptions.Upload);
                    this._setNavOptionVisibleState(this._workflow, isLogon ? false : navOptions.Workflow);
                    this._setNavOptionVisibleState(this._forms, isLogon ? false : navOptions.Forms);
                    let onePersonalVisible = navOptions.MyFolders || navOptions.MyDocuments || navOptions.SavedSearches;
                    this._setNavOptionVisibleState(this._personalList, isLogon || this._useSimplePersonal ? false : onePersonalVisible);
                    this._setNavOptionVisibleState(this._myFolders, isLogon ? false : navOptions.MyFolders);
                    this._setNavOptionVisibleState(this._myDocuments, isLogon ? false : navOptions.MyDocuments);
                    this._setNavOptionVisibleState(this._savedSearch, isLogon ? false : navOptions.SavedSearches);
                    this._setNavOptionVisibleState(this._languageOptions, navOptions.Lang);
                    this._setNavOptionVisibleState(this._changePw, isLogon ? false : navOptions.ChangePw);
                    this._setNavOptionVisibleState(this._forgotPw, isLogon ? navOptions.ForgotPw : false);
                    this._setNavOptionVisibleState(this._myProfile, isLogon ? false : navOptions.MyProfile);
                    this._setNavOptionVisibleState(this._adminPage, isLogon ? false : navOptions.AdminPage);
                    this._setNavOptionVisibleState(this._logOff, !isLogon);
                    this._setNavOptionVisibleState(this._logIn, isLogon);
                    this._setCustomNavOptionsVisibility(isLogon);
                };
                this._setCustomNavOptionsVisibility = (isLogon) => {
                    this._log.info("MenuNavigationHandler._setCustomNavOptionsVisibility()");
                    let counter = 0;
                    this._customNavOptions.forEach(o => {
                        counter++;
                        let customItem = this._sideNavList.querySelector('#customItem-' + counter);
                        let defaultVisibility = o.OnlyOnLogon ? false : true;
                        this._setNavOptionVisibleState(customItem, isLogon ? o.OnLogon : defaultVisibility);
                    }, this);
                };
                this._setNavOptionVisibleState = (element, isVisible) => {
                    this._log.info("MenuNavigationHandler._setNavOptionVisibleState()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("switching element: " + element.id);
                        this._log.trace("is visible? " + isVisible);
                    }
                    if (isVisible) {
                        this._core.Functions.showElement(element);
                    }
                    else {
                        this._core.Functions.hideElement(element);
                    }
                };
                this._backToHomepage = () => {
                    this._log.info("MenuNavigationHandler._backToHomepage()");
                    let targetLayout = WPTNamespace.Navigation.HOME_VIEW_NAME;
                    let config = this._core.Config.getApplicationConfig();
                    if (config.hasOwnProperty('HomeButtonTargetLayout') && config.HomeButtonTargetLayout)
                        targetLayout = config.HomeButtonTargetLayout;
                    let navEvent = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.NONE);
                    navEvent.Layout = targetLayout;
                    if (this._core.Navigation.Details.getActiveLayoutName() != targetLayout)
                        this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._userClicked = () => {
                    this._log.info("MenuNavigationHandler._userClicked()");
                    let config = this._core.Config.getApplicationConfig();
                    if (config.hasOwnProperty('Content') && config.Content.hasOwnProperty('UserAction')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got user action: " + config.Content.UserAction);
                        }
                        switch (config.Content.UserAction) {
                            case "about":
                                this._showAbout();
                                break;
                            case "change-password":
                                this.showChangePw();
                                break;
                            case "user-settings":
                                this._showUserSettings();
                                break;
                            default:
                                this._showUserSettings();
                                break;
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no user action configured, using default: user-settings");
                        }
                        this._showUserSettings();
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("MenuNavigationHandler::constructor");
            }
        }
        Navigation.MenuNavigationHandler = MenuNavigationHandler;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
